// extracted by mini-css-extract-plugin
export default {"container":"gdkLN","back-office":"sMCNi","backOffice":"sMCNi","success":"myCgw","error":"lBRzW","info":"c5Dhd","center":"uwZ9x","static":"VLSS-","close":"e8+Xd"};